export const mockData = {
  menuCategories: [
    {
      name: "🎉 PROMOTIONS",
      description: "Offres spéciales",
      isPromo: true,
      items: [
        {
          name: "Promo 1 – 3 Pizzas Junior + Coca 1,5L",
          price: "23,90 €",
          description: "Choisissez 3 pizzas Junior de votre choix + 1 Maxi Coca 1,5L",
          promoType: "3_junior_pizzas"
        },
        {
          name: "Promo 2 – 2 Pizzas Senior + Coca 1,5L",
          price: "23,90 €",
          description: "Choisissez 2 pizzas Senior de votre choix + 1 Maxi Coca 1,5L",
          promoType: "2_senior_pizzas"
        },
        {
          name: "Promo 3 – 2 Pizzas Mega + Coca 1,5L",
          price: "32,90 €",
          description: "Choisissez 2 pizzas Mega de votre choix + 1 Maxi Coca 1,5L",
          promoType: "2_mega_pizzas"
        }
      ]
    },
    {
      name: "🍕 MENUS MIDIS",
      description: "9,50 €",
      items: [
        { name: "Menu Pizza", price: "9,50 €", description: "1 Pizza Junior + 1 dessert (sauf glace) + 1 boisson 33cl", menuType: "pizza_midi" },
        { name: "Menu Salade", price: "9,50 €", description: "1 Salade + 1 dessert (sauf glace) + 1 boisson 33cl", menuType: "salade_midi" },
        { name: "Menu Pâtes", price: "9,50 €", description: "1 Plat de pâtes + 1 dessert (sauf glace) + 1 boisson 33cl", menuType: "pates_midi" },
        { name: "Menu Sandwich", price: "9,50 €", description: "1 Sandwich + frites + 1 dessert (sauf glace) + 1 boisson 33cl", menuType: "sandwich_midi" }
      ]
    },
    {
      name: "👶 MENU BAMBINO",
      description: "7,00 €",
      items: [
        { name: "Menu Bambino", price: "7,00 €", description: "1 mini pizza Classica + 1 ingrédient au choix + 5 nuggets + frites + 1 Kinder + 1 Caprisun", menuType: "bambino" }
      ]
    },
    {
      name: "🍕 PIZZAS BASE SAUCE TOMATE",
      description: "Base sauce tomate + fromage • Tailles: Junior (7€), Senior (10€/14€), Mega (15€/19,50€/21,50€/22€)",
      items: [
        { name: "Classica", price: "7,00 €", description: "tomate, fromage, origan", basePrice: { junior: 7, senior: 10, mega: 15 } },
        { name: "Torino", price: "8,00 €", description: "+ jambon, champignons", basePrice: { junior: 8, senior: 14, mega: 19.5 } },
        { name: "Campione", price: "8,00 €", description: "+ viande hachée, champignons", basePrice: { junior: 8, senior: 14, mega: 19.5 } },
        { name: "Paysanne", price: "8,00 €", description: "+ lardons, œuf", basePrice: { junior: 8, senior: 14, mega: 19.5 } },
        { name: "Chorizo", price: "8,00 €", description: "+ chorizo, poivrons", basePrice: { junior: 8, senior: 14, mega: 19.5 } },
        { name: "Calzone", price: "8,00 €", description: "+ jambon, œuf", basePrice: { junior: 8, senior: 14, mega: 19.5 } },
        { name: "Napolitaine", price: "8,00 €", description: "+ câpres, anchois, olives", basePrice: { junior: 8, senior: 14, mega: 19.5 } },
        { name: "Orientale", price: "9,00 €", description: "+ merguez, poivrons, oignons, œuf", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Capri", price: "9,00 €", description: "+ fruits de mer, ail, persil", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Neptune", price: "9,00 €", description: "+ thon, poivrons, olives, œuf", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Aubergine", price: "9,00 €", description: "+ aubergines, viande hachée, poivrons", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Hawaïenne", price: "9,00 €", description: "+ jambon, ananas", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "San Pietro", price: "9,00 €", description: "+ jambon, chorizo, merguez, champignons", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "3 Jambons", price: "9,00 €", description: "jambon, chorizo, lardons", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Roma", price: "9,00 €", description: "jambon, artichauts, poivrons", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Fromaggi", price: "9,00 €", description: "+ chèvre, brie, gorgonzola", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Fajitas", price: "9,00 €", description: "+ poulet, champignons, oignons, ail", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Texas", price: "9,00 €", description: "+ viande hachée, chorizo, oignons", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Végétarienne", price: "9,00 €", description: "+ artichauts, oignons, aubergines, poivrons, olives", basePrice: { junior: 9, senior: 16, mega: 21.5 } },
        { name: "Bolognaise", price: "10,00 €", description: "+ viande hachée, pommes de terre", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } },
        { name: "Cannibale", price: "10,00 €", description: "+ poulet, merguez, boulettes bœuf", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } },
        { name: "Raclette", price: "10,00 €", description: "+ lardons, raclette, champignons, persillade", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } },
        { name: "Roquette", price: "10,00 €", description: "+ jambon, tomates cerises, roquette, parmesan", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } },
        { name: "Kebab", price: "10,00 €", description: "+ émincé kebab, oignons, tomates fraîches", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } },
        { name: "Indienne", price: "10,00 €", description: "+ sauce curry, fromage, poulet", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } },
        { name: "Mexicaine", price: "9,00 €", description: "+ viande hachée, merguez, œuf", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Barbecue", price: "10,00 €", description: "sauce barbecue, fromage, viande hachée", basePrice: { junior: 10, senior: 16.5, mega: 22.0 } }
      ]
    },
    {
      name: "🍕 PIZZAS BASE CRÈME FRAÎCHE",
      description: "Base crème fraîche + fromage • Junior (9€), Senior (16€), Mega (21,50€)",
      items: [
        { name: "Chèvre Miel", price: "9,00 €", description: "chèvre, miel", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Sardaigne", price: "9,00 €", description: "gorgonzola, chèvre, brie", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Venizia", price: "9,00 €", description: "saumon fumé, citron", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Boursin", price: "9,00 €", description: "viande hachée, boursin, œuf", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Supreme", price: "9,00 €", description: "poulet, champignons, gorgonzola", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Ibiza", price: "9,00 €", description: "poulet, boursin, pommes de terre", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Florentine", price: "9,00 €", description: "lardons, oignons, chèvre, roquette", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Boisée", price: "9,00 €", description: "sauce fromagère, poulet, poivrons", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Fermière", price: "9,00 €", description: "poulet, pommes de terre, champignons", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Tartiflette", price: "9,00 €", description: "lardons, reblochon, pommes de terre, oignons", basePrice: { junior: 9, senior: 16, mega: 21.50 } },
        { name: "Croustillante", price: "9,00 €", description: "poulet, chèvre, miel", basePrice: { junior: 9, senior: 16, mega: 21.50 } }
      ]
    },
    {
      name: "🌮 TACOS",
      description: "8,00 € • Viandes: grec, chicken, viande hachée, merguez, nuggets, cordon bleu, tenders",
      items: [
        { name: "Tacos", price: "8,00 €", description: "Viandes au choix + sauces + frites incluses" }
      ]
    },
    {
      name: "🍔 BURGERS",
      description: "Servi avec Frites et Boisson",
      items: [
        { name: "Méga", price: "7,90 €", description: "1 steak 90g" },
        { name: "Double Méga", price: "8,90 €", description: "2 steaks 90g" },
        { name: "Triple Méga", price: "9,90 €", description: "3 steaks 90g" },
        { name: "Menu Hamburger", price: "8,90 €", description: "Hamburger complet" }
      ]
    },
    {
      name: "🥖 SANDWICHS",
      description: "9,00 € • Servi avec Frites et Boisson",
      items: [
        { name: "Grec", price: "9,00 €", description: "salade, tomates, oignons" },
        { name: "Chicken", price: "9,00 €", description: "salade, tomates, oignons" },
        { name: "Steak", price: "9,00 €", description: "salade, tomates, oignons" }
      ]
    },
    {
      name: "🥙 ZAPDWICHS",
      description: "8,50 € • Servi avec Boisson • Garnis de tomates et mozzarella",
      items: [
        { name: "Thon", price: "8,50 €" },
        { name: "Saumon", price: "8,50 €" },
        { name: "Jambon", price: "8,50 €" },
        { name: "Poulet", price: "8,50 €" },
        { name: "4 Fromages", price: "8,50 €" },
        { name: "Bœuf haché", price: "8,50 €" }
      ]
    },
    {
      name: "🍝 PÂTES",
      description: "8,90 €",
      items: [
        { name: "Saumon", price: "8,90 €", description: "crème, saumon" },
        { name: "Carbonara", price: "8,90 €", description: "crème, lardons" },
        { name: "Bolognaise", price: "10,00 €", description: "bœuf à la tomate" },
        { name: "4 Fromages", price: "8,90 €", description: "chèvre, reblochon, roquefort, parmesan" }
      ]
    },
    {
      name: "🥗 SALADES",
      description: "7,90 € • Pain offert",
      items: [
        { name: "Norvégienne", price: "7,90 €", description: "salade, tomates, saumon, citron" },
        { name: "Poulet", price: "7,90 €", description: "salade, tomates, poulet, emmental, maïs, œuf" },
        { name: "Niçoise", price: "7,90 €", description: "salade, tomates, thon, pommes de terre, œuf" },
        { name: "Printanière", price: "7,90 €", description: "salade, tomates, jambon, emmental, œuf" },
        { name: "Avocat Crevettes", price: "7,90 €", description: "salade, tomates, crevettes, avocat" },
        { name: "Royale", price: "7,90 €", description: "salade, tomates, chèvre, croûtons, lardons" },
        { name: "Mozza", price: "7,90 €", description: "salade, tomates, mozzarella, huile d'olive, basilic" }
      ]
    },
    {
      name: "🌶️ TEX MEX",
      description: "8 pièces (8,90 €) ou 12 pièces (11,90 €)",
      items: [
        { name: "Mozza Sticks", price: "8,90 €", description: "8 ou 12 pièces" },
        { name: "Nuggets", price: "8,90 €", description: "8 ou 12 pièces" },
        { name: "Onion Rings", price: "8,90 €", description: "8 ou 12 pièces" },
        { name: "Jalapeños", price: "8,90 €", description: "8 ou 12 pièces" },
        { name: "MUX", price: "11,90 €", description: "12 pièces uniquement", fixedSize: true }
      ]
    },

    {
      name: "🥐 PANINIS",
      description: "5,00 € (Nutella 4,00 €)",
      items: [
        { name: "Thon", price: "5,00 €" },
        { name: "Saumon", price: "5,00 €" },
        { name: "Jambon", price: "5,00 €" },
        { name: "Poulet", price: "5,00 €" },
        { name: "4 Fromages", price: "5,00 €" },
        { name: "Bœuf haché", price: "5,00 €" },
        { name: "Nutella", price: "4,00 €" }
      ]
    },
    {
      name: "🍰 DESSERTS",
      items: [
        { name: "Brownie", price: "2,50 €" },
        { name: "Tiramisu", price: "3,00 €" },
        { name: "Tarte du daim", price: "3,00 €" }
      ]
    },
    {
      name: "🍦 GLACES",
      items: [
        { name: "Haagen-Dazs Pot 100ml", price: "3,50 €" },
        { name: "Haagen-Dazs Pot 500ml", price: "8,00 €" }
      ]
    },
    {
      name: "🥤 BOISSONS",
      items: [
        { name: "Coca / Coca Zero", price: "1,50 €" },
        { name: "Fanta Orange", price: "1,50 €" },
        { name: "Oasis / Tropico", price: "1,50 €" },
        { name: "Ice Tea", price: "1,50 €" },
        { name: "Maxi Coca 1,5 L", price: "3,00 €" },
        { name: "Maxi Oasis 2 L", price: "3,50 €" }
      ]
    }
  ],
  info: {
    address: "234 Rue de Paris, 91120 Palaiseau",
    phone: "01 69 19 15 05",
    googleMapsLink: "https://www.google.com/maps/search/234+Rue+de+Paris+91120+Palaiseau",
    directionsLink: "https://www.google.com/maps/dir/?api=1&destination=234+Rue+de+Paris,91120+Palaiseau"
  },
  gallery: [
    { src: "https://images.unsplash.com/photo-1513104890138-7c749659a591", alt: "Pizza rustique" },
    { src: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38", alt: "Pizza Hawaiian" },
    { src: "https://images.unsplash.com/photo-1593504049359-74330189a345", alt: "Pizza fromage" },
    { src: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd", alt: "Burger" },
    { src: "https://images.unsplash.com/photo-1606131731446-5568d87113aa", alt: "Burger gourmet" },
    { src: "https://images.unsplash.com/photo-1624300629298-e9de39c13be5", alt: "Tacos" },
    { src: "https://images.pexels.com/photos/2092507/pexels-photo-2092507.jpeg", alt: "Tacos présentés" },
    { src: "https://images.unsplash.com/photo-1551024506-0bccd828d307", alt: "Dessert glace" }
  ],
  about: [
    {
      icon: "🍕",
      title: "Ingrédients Frais",
      description: "Pizzas préparées avec des ingrédients frais et de qualité."
    },
    {
      icon: "🥩",
      title: "Viandes Halal",
      description: "Toutes nos viandes sont certifiées halal pour votre tranquillité d'esprit."
    },
    {
      icon: "⚡",
      title: "Livraison Rapide",
      description: "Service de livraison rapide à Palaiseau et environs. Commandez par téléphone."
    }
  ],
  paymentInfo: [
    "💳 Paiement par carte bancaire",
    "💵 Espèces acceptées",
    "🛵 Livraison disponible",
    "📞 Commandez par téléphone"
  ],
  heroSlogan: "Authenticité, saveur et passion – dans chaque pizza.",
  promoBanner: "Livraison : 2 pizzas Senior ou Mega achetées = la 3ème offerte (la moins chère, hors Classica).",
  promoBanner2: "À emporter : 2ème pizza Senior à 2 € • 2ème pizza Mega à 4 € (hors Classica).",
  promoBanner3: "À emporter ou Livraison : 1 pizza achetée = la 2ème à -50 % (valable Senior & Mega, hors Classica).",
  pizzaIngredients: {
    vegetables: ["Oignons", "Poivrons", "Champignons", "Aubergines", "Artichauts", "Pommes de terre", "Olives", "Tomates cerises", "Câpres"],
    meats: ["Jambon", "Chorizo", "Lardons", "Viande hachée", "Poulet", "Merguez", "Boulettes bœuf", "Kebab", "Fruits de mer", "Thon", "Anchois", "Saumon fumé"],
    cheeses: ["Mozzarella", "Chèvre", "Brie", "Gorgonzola", "Reblochon", "Boursin", "Parmesan", "Raclette"],
    extras: ["Œuf", "Ananas", "Sauce curry", "Sauce barbecue", "Sauce fromagère", "Miel", "Citron"]
  },
  sauces: ["Ketchup", "Mayo", "Blanche", "Algérienne", "Samouraï", "Barbecue", "Biggy", "Andalouse", "Fromagère"],
  drinks33cl: ["Coca", "Coca Zero", "Fanta", "Oasis", "Ice Tea"],
  horaires: [
    { day: "Lundi", hours: "11h00–14h30, 18h00–23h00" },
    { day: "Mardi", hours: "11h00–14h30, 18h00–23h00" },
    { day: "Mercredi", hours: "11h00–14h30, 18h00–23h00" },
    { day: "Jeudi", hours: "11h00–14h30, 18h00–23h00" },
    { day: "Vendredi", hours: "11h00–14h30, 18h00–23h00" },
    { day: "Samedi", hours: "11h00–14h30, 18h00–23h00" },
    { day: "Dimanche", hours: "18h00–23h00" }
  ]
};